import React from 'react'
import { Card, Row, Col, Form } from 'react-bootstrap'
import { currencyConvert } from '../../../../../utility/convert.util'

const FinancialSummary = ({ invoice }) => {
  return (
    <div>
      <fieldset class="scheduler-border">
        <legend class="scheduler-border font-medium">สรุปการเงิน</legend>

        <Row>
          <Col sm="12" className="d-flex justify-content-end">
            <Form>
              <Form.Group as={Row} className="mb-2">
                <Form.Label column sm={4} className="text-right">
                  รวมเงิน
                </Form.Label>
                <Col sm={8}>
                  <Form.Control
                    type="text"
                    value={currencyConvert(invoice?.summaryCharge?.totalAmount)}
                    readOnly
                    className="text-right"
                  />
                </Col>
              </Form.Group>

              <Form.Group as={Row} className="mb-2">
                <Form.Label column sm={4} className="text-right text-success">
                  ส่วนลด
                </Form.Label>
                <Col sm={8}>
                  <Form.Control
                    type="text"
                    value={currencyConvert(
                      invoice?.summaryCharge?.totalDiscountAmount,
                    )}
                    readOnly
                    className="text-right bg-success text-white border-none"
                  />
                </Col>
              </Form.Group>

              <Form.Group as={Row} className="mb-2">
                <Form.Label column sm={4} className="text-right text-danger">
                  ค้างชำระ
                </Form.Label>
                <Col sm={8}>
                  <Form.Control
                    type="text"
                    value={currencyConvert(
                      invoice?.summaryCharge?.totalArrearAmount,
                    )}
                    readOnly
                    className="text-right bg-danger border-none text-white"
                  />
                </Col>
              </Form.Group>

              <Form.Group as={Row} className="mb-2">
                <Form.Label
                  column
                  sm={4}
                  className="text-right"
                  style={{
                    color: '#666699',
                  }}
                >
                  ลูกหนี้สิทธิ
                </Form.Label>
                <Col sm={8}>
                  <Form.Control
                    type="text"
                    value={currencyConvert(
                      invoice?.summaryCharge?.totalInsuranceAmount,
                    )}
                    readOnly
                    className="text-right border-none text-white"
                    style={{
                      backgroundColor: '#666699',
                    }}
                  />
                </Col>
              </Form.Group>

              <Form.Group as={Row} className="mb-2">
                <Form.Label
                  column
                  sm={4}
                  className="text-right text-primary"
                  style={{ fontSize: '20px' }}
                >
                  รวมชำระ
                </Form.Label>
                <Col sm={8}>
                  <Form.Control
                    type="text"
                    value={currencyConvert(
                      invoice?.summaryCharge?.totalPayAmount,
                    )}
                    readOnly
                    className="text-right bg-primary text-white border-none"
                  />
                </Col>
              </Form.Group>
            </Form>
          </Col>
        </Row>
      </fieldset>
    </div>
  )
}

export default FinancialSummary
